import {useSelectedCommunities} from '@ark/web';
import React from 'react';
import {SidebarItemBadge} from '../SidebarItemBadge';
import {useSafetyRosterNeedsActionCountQuery} from '@/generated/graphql';

type Props = {
  children: React.ReactNode;
};

export const PcfraOutstandingBadge = (props: Props) => {
  const communities = useSelectedCommunities();

  const {data} = useSafetyRosterNeedsActionCountQuery({
    variables: {communities},
    pollInterval: 300_000,
    fetchPolicy: 'cache-and-network',
  });

  return (
    <SidebarItemBadge
      badgeContent={data?.safetyRoster?.counts.needsAction || 0}
      tooltipContent="Occupants that need action"
    >
      {props.children}
    </SidebarItemBadge>
  );
};
